import { Image } from "@chakra-ui/react";
export const ImageBasic = (props) => (
  <Image
    // alignSelf={"center"}
    {...props}
  />
);
